import React from 'react';
import css from './GetStarted.module.scss';
import {Section} from '../section/Section';
import {useScrollService} from '../ScrollService';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';
import {SETUP_STEP_TYPES} from '../../../setupSteps/SetupStepTypes';

export const GetStartedSection: React.FC<{
  type: SETUP_STEP_TYPES;
}> = ({type}) => {
  let scroller = useScrollService();

  return (
    <Section type={type}>
      <div className={css.section_get_started}>
        <div className={css.section_get_started_header_container}>
          <div className={css.section_get_started_title}>
            Unlock a new level of interaction with Pulsoid
          </div>
          <div className={css.section_get_started_text}>
            Welcome to Pulsoid! With our app, you can seamlessly display your
            heart rate during streams or in VRChat, adding a new layer of
            interaction. Getting started is quick and easy—just connect a
            compatible device, and you'll be set up in minutes. Enjoy the
            experience!
          </div>
        </div>
        <iframe
          className={css.section_get_started_video}
          src="https://www.youtube.com/embed/BaxWB6zqIWg"
          title="Show your heart rate on stream with Pulsoid"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
        <ButtonV2
          size="small"
          className={css.get_started_button}
          onClick={() => scroller.current.scroll('heart-rate-monitors')}
        >
          Get Started
        </ButtonV2>
      </div>
    </Section>
  );
};
